/**
 * Haut d'écran sur l'app native (iPhone : barre d'état / encoche).
 *
 * Avant, chaque page devait réserver `env(safe-area-inset-top)` elle-même :
 * toute page hors des espaces élève / prof / parent / curieux (dont le `<main>`
 * le fait) qui l'oubliait avait son bouton retour CACHÉ sous l'heure et la
 * batterie (résultats d'un essai, rendez-vous, bilan, cadeaux, lot…).
 * Désormais la racine le réserve pour TOUTES les pages, sauf celles de cette
 * liste qui le gèrent déjà (sinon l'espace serait doublé). Une nouvelle page
 * est donc protégée par défaut. PUR, testé.
 */

/** Routes (et leurs enfants) qui réservent déjà le haut d'écran elles-mêmes. */
export const SELF_SAFE_TOP_ROUTES: readonly string[] = [
  // Espaces avec menu : le `<main>` du layout réserve l'espace.
  '/app/tutor',
  '/app/student',
  '/app/parent',
  '/app/player',
  // Pages qui le gèrent elles-mêmes (couverture pleine largeur, en-tête collant…).
  '/app/profile',
  '/app/discussions/$discussionId',
  '/app/blog/$slug',
  '/app/learn',
  '/card/$cardId',
  '/card/$cardId/acheter',
  '/pack/$packId/acheter',
  '/debloquer/$offer/$packId',
  '/payer/$token',
  '/reserver/$slotId',
  '/login',
  '/decouverte',
  // Démo sans compte (et son enfant `/demo/exercise/$exerciseId`) : écran de fin
  // bleu nuit plein écran, les autres écrans le font dans leur en-tête.
  '/demo',
  '/live/$niveau',
  '/defi-live/$code',
  '/app/live/prive/nouveau',
];

/** La page affichée (ids des routes correspondantes) doit-elle recevoir l'espace du haut ? */
export function needsTopSafeArea(routeIds: readonly string[]): boolean {
  return !routeIds.some((id) =>
    SELF_SAFE_TOP_ROUTES.some((route) => id === route || id.startsWith(`${route}/`)),
  );
}
